<ng-template #contentHeaderTemplate>
  @if (!absenceRequest) {
    <div class="row">
      <div class="col-12 d-flex justify-content-end ">
        <button class="btn btn-primary" (click)="save()">
          {{ 'authenticated.time_tracking.absence_requests.create.save_btn' | translate }}
        </button>
      </div>
    </div>
  }
</ng-template>

<div class="row g-3">

  <div class="col-12 col-md-9 order-md-1">
    <form [formGroup]="form" (submit)="save()">
      <div class="card mb-3">
        <div class="card-header">
          {{ 'authenticated.time_tracking.absence_requests.edit.header' | translate }}
        </div>
        <div class="card-body">

          <div class="row">

            @if (mode === EditModeEnum.CREATE) {
              <div class="col-12">
                <div class="alert alert-primary">
                  {{ 'authenticated.time_tracking.absence_requests.create_info_text' | translate }}
                </div>
              </div>
            }

            @if (showTimeTrackingEmployee && absenceRequest?.time_tracking_employee?.user?.name) {
              <div class="col-12 col-lg-6 py-1">
                <app-read-only-static
                  [value]="absenceRequest?.time_tracking_employee?.user?.name ?? ''"
                  label="{{'authenticated.time_tracking.absence_requests.edit.form.time_tracking_employee.label' | translate }}"
                ></app-read-only-static>
              </div>

              <div class="col-lg-6 py-1"></div>
            }

            <div class="col-12 col-lg-6 py-1">
              <app-date-time
                [formControl]="form.controls.start_at"
                [timeMode]="TIME_MODE.START_OF_DAY"
                label="{{'authenticated.time_tracking.absence_requests.edit.form.start_at.label' | translate }}"
                [errorMessages]="{required: ('authenticated.time_tracking.absence_requests.edit.form.start_at.validation_messages.required' | translate)}"
              ></app-date-time>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-date-time
                [formControl]="form.controls.end_at"
                [timeMode]="TIME_MODE.END_OF_DAY"
                label="{{'authenticated.time_tracking.absence_requests.edit.form.end_at.label' | translate }}"
                [errorMessages]="{required: ('authenticated.time_tracking.absence_requests.edit.form.end_at.validation_messages.required' | translate)}"
              ></app-date-time>
            </div>

            <div class="col-12 py-1">
              <app-form-group
                type="textarea"
                [formControl]="form.controls.note_employee"
                label="{{'authenticated.time_tracking.absence_requests.edit.form.note_employee.label' | translate }}"
              ></app-form-group>
            </div>

            @if (mode === EditModeEnum.EDIT) {
              <div class="col-12 py-1">
                <app-form-group
                  type="textarea"
                  [formControl]="processForm.controls.note_team_leader_hr"
                  label="{{'authenticated.time_tracking.absence_requests.edit.form.note_team_leader_hr.label' | translate }}"
                ></app-form-group>
              </div>
            }

            @if (canProcess()) {
              <div class="col-12 py-1 d-flex justify-content-end gap-3">
                <button class="btn btn-primary" type="button" (click)="submitProcessForm(TimeTrackingAbsenceRequestStateEnum.APPROVED)">
                  {{ 'authenticated.time_tracking.absence_requests.edit.approved.btn' | translate }}
                </button>

                <button class="btn btn-danger" type="button" (click)="submitProcessForm(TimeTrackingAbsenceRequestStateEnum.REJECTED)">
                  {{ 'authenticated.time_tracking.absence_requests.edit.rejected.btn' | translate }}
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="col-12 col-md-3 order-md-2">
    @if (absenceRequest) {
      <div class="card mb-3">
        <div class="card-header">
          {{ 'authenticated.time_tracking.absence_requests.edit.settings_card_header' | translate }}
        </div>
        <div class="card-body">
          <div class="row">

            <div class="col-12 py-1">
              <app-read-only-static
                [value]="('enums.timeTrackingAbsenceRequestStateEnum.' + absenceRequest.state) | translate"
                label="{{'authenticated.time_tracking.absence_requests.edit.form.state.label' | translate }}"
              ></app-read-only-static>
            </div>

            <div class="col-12 py-1">
              <app-read-only-static
                [value]="absenceRequest.processed_by?.name"
                label="{{'authenticated.time_tracking.absence_requests.edit.form.processed_by_id.label' | translate }}"
              ></app-read-only-static>
            </div>

            <div class="col-12 py-1">
              <app-read-only-static
                [value]="absenceRequest.cancelled_by?.name"
                label="{{'authenticated.time_tracking.absence_requests.edit.form.cancelled_by_id.label' | translate }}"
              ></app-read-only-static>
            </div>

            <div class="col-12 pt-2 pb-1">
              <button (click)="cancel()" class="btn btn-danger w-100" [disabled]="!absenceRequest.actions.cancel">
                {{ 'authenticated.time_tracking.absence_requests.edit.cancel.btn' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    }
  </div>

</div>
